export default __webpack_public_path__ + "static/media/Untitled-design.770cd45c.jpg";